import { Spinner } from '@legalcrm/ui';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LandingPage } from '@/routes/landing/LandingPage';

import { useAuth } from './AuthProvider';

/**
 * Route guard.
 *
 * Again: a convenience, not a control. It stops a signed-out user staring at an empty
 * shell; it does not protect the data, because there is no data without a token the
 * server accepts.
 *
 * The current location is carried through so a session that expires mid-task returns
 * the user to where they were rather than to the dashboard.
 */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" label="Loading your account" />
      </div>
    );
  }

  if (!isAuthenticated) {
    // The bare domain is the product's front door: a visitor who has never signed in
    // should read what it is, not meet a password box. Every deeper path still goes
    // straight to sign-in and comes back afterwards.
    if (location.pathname === '/') return <LandingPage />;
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
